import React from 'react';
import { Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { selectAuthComptable } from '../Redux/authComptableSlice';

const PrivateRouteComptable = ({ children, redirectPath = "/comptable/login" }) => {
  const isAuthenticated = useSelector((state) => selectAuthComptable(state).isAuthenticated);

  return isAuthenticated ? children : <Navigate to={redirectPath} replace />;
};

export default PrivateRouteComptable;
